import React, { useEffect, useState, useRef } from "react";
// import { useTranslation } from "react-i18next";

interface SearchableDropdownProps {
  addressOptions: { id: string; name: string; outlet_id: string }[];
  selectedAddress: string;
  handleAddressSelectChange: (
    event: React.ChangeEvent<HTMLSelectElement> | null
  ) => void;
  loading: boolean;
  error: string | null;
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  addressError?: boolean;
  setAddressError: (value: boolean) => void;
  label?: boolean;
}

const SearchableDropdown: React.FC<SearchableDropdownProps> = ({
  addressOptions,
  selectedAddress,
  handleAddressSelectChange,
  loading,
  error,
  searchTerm,
  setSearchTerm,
  addressError,
  setAddressError,
  label = true,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  // const { t } = useTranslation();
  const dropdownRef = useRef<HTMLDivElement>(null);

  const filteredOptions = addressOptions?.filter((option) =>
    option.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelect = (selectedValue: string) => {
    const selectedOption = addressOptions.find(
      (opt) => opt.outlet_id === selectedValue
    );

    if (!selectedOption) return;

    const syntheticEvent = {
      target: {
        value: selectedOption.outlet_id,
        dataset: { id: selectedOption.id },
      },
    } as unknown as React.ChangeEvent<HTMLSelectElement>;

    handleAddressSelectChange(syntheticEvent);
    setSearchTerm(selectedOption.name || "");
    setIsOpen(false);
    setAddressError(false);
  };

  const handleSetSearchTerm = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value === "") {
      handleAddressSelectChange(null);
      setSearchTerm("");
    }
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} className="relative w-full">
      <div
        className={`border rounded px-3 py-2 bg-white cursor-pointer ${addressError ? "border-red-500" : ""}`}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <span className="text-sm font-medium text-gray-700">
          {selectedAddress
            ? addressOptions.find((opt) => opt.outlet_id === selectedAddress)?.name || "Select Territory_identifier"
            : "Select Territory_identifier"}
        </span>
      </div>
      {isOpen && (
        <div className="absolute z-10 mt-1 w-full bg-white border rounded max-h-60 overflow-auto shadow-lg">
          <input
            type="text"
            placeholder="Search..."
            className="w-full p-2 border-b outline-none"
            value={searchTerm}
            onChange={handleSetSearchTerm}
            autoFocus
          />
          {filteredOptions?.length > 0 ? (
            filteredOptions.map((option) => (
              <div
                key={option.id}
                className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${
                  selectedAddress === option.outlet_id ? "bg-gray-200 font-medium" : ""
                }`}
                onClick={() => handleSelect(option.outlet_id)}
              >
                {option.name}
              </div>
            ))
          ) : (
            <div className="px-4 py-2 text-gray-500">No results found</div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchableDropdown;
